export default __webpack_public_path__ + "static/media/number-1.2f00136a.svg";